let $textareas;

function _setupTextarea($textarea) {
    let $wrapper = document.createElement('div'),
        $counter = document.createElement('span')
    ;

    $wrapper.classList.add('limited-textarea');
    $counter.classList.add('characters-remaining');

    $textarea.parentNode.insertBefore($wrapper, $textarea);
    $wrapper.appendChild($textarea);
    $wrapper.appendChild($counter);

    $textarea.addEventListener('keyup', event => {
        if ($textarea.value.length > 90) {
            $textarea.value = $textarea.value.substring(0, 90);
        }

        let remaining = 90 - $textarea.value.length,
            plural = remaining === 1 ? '' : 's'
        ;

        $counter.innerText = `${remaining} character${plural} remaining.`;
    });

    $textarea.addEventListener('keydown', event => {
        if (90 - $textarea.value.length > 0) {
            return;
        }

        //typically letter/number/character keys are single digit
        //this essentially allows us to still press tab/backspace/etc when the input is full
        //@todo Allow for Cmd/Ctrl + A
        if (event.key.length > 1 & event.key !== 'Enter' && event.key !== 'Return') {
            return;
        }

        event.stopImmediatePropagation();
        event.preventDefault();
        return false;
    });

    $textarea.dispatchEvent(new Event('keyup'));
}


function _init() {
    $textareas = document.querySelectorAll('textarea[data-limit]');

    if ($textareas.length === 0) {
        return;
    }

    for (let $textarea of $textareas) {
        _setupTextarea($textarea);
    }
}

document.addEventListener('DOMContentLoaded', _init);